// 公共动画方法
function initSmoothBlocks({
  selector = '.landing-block',
  visibleClass = 'is-visible',
  offset = 0.2, // 进入多少视口高度触发
  transition = 'all 0.8s cubic-bezier(0.25, 1, 0.5, 1)'
} = {}) {
  const blocks = document.querySelectorAll(selector);

  // 统一设置初始样式
  blocks.forEach(block => {
    block.style.opacity = '0';
    block.style.transform = 'translateY(40px)';
    block.style.transition = transition;
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add(visibleClass);
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: offset });

  blocks.forEach(block => observer.observe(block));
}

// 页面加载时初始化
document.addEventListener("DOMContentLoaded", () => {
  initSmoothBlocks();
});
